var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoyalty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.5C19.4036 25.5 25 19.9036 25 13C25 6.09644 19.4036 0.5 12.5 0.5C5.59644 0.5 0 6.09644 0 13C0 19.9036 5.59644 25.5 12.5 25.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.9632C17.4502 21.9632 21.4632 17.9502 21.4632 13C21.4632 8.04976 17.4502 4.0368 12.5 4.0368C7.54976 4.0368 3.5368 8.04976 3.5368 13C3.5368 17.9502 7.54976 21.9632 12.5 21.9632Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 1.4535
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51484 16.9082L6.93652 11.4481C6.87149 11.2231 7.08555 11.0175 7.30771 11.0916L10.07 12.0123C10.1899 12.0523 10.3219 12.0102 10.3965 11.9082L12.4057 9.16091C12.5233 9.00017 12.764 9.00254 12.8784 9.16557L14.7963 11.8997C14.871 12.0061 15.0071 12.05 15.1298 12.0073L17.7346 11.1013C17.9574 11.0238 18.1749 11.23 18.1094 11.4566L16.5335 16.9082C16.4976 17.0326 16.3837 17.1182 16.2542 17.1182H8.79411C8.66465 17.1182 8.55079 17.0326 8.51484 16.9082Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyalty);
export default __webpack_public_path__ + "static/media/loyalty.6f7cd740f1240807a9bde6d5e05fb8ae.svg";
export { ForwardRef as ReactComponent };